module.exports = __webpack_public_path__ + "img/img-601b92.jpg";